import { ReactNode } from 'react';
import { Breadcrumb, type BreadcrumbItem } from './Breadcrumb';

export function RecordHeader({
  avatarInitials: _avatarInitials,
  title,
  meta,
  actionsEnd,
  breadcrumb,
  className,
}: {
  /** @deprecated Avatar is no longer rendered — kept for API compatibility. */
  avatarInitials?: string;
  title: string;
  meta?: string;
  actionsEnd?: ReactNode;
  breadcrumb?: BreadcrumbItem[];
  className?: string;
}) {
  const crumbs = breadcrumb && breadcrumb.length > 0 ? <Breadcrumb items={breadcrumb} /> : null;
  return (
    <div className={['border-b vscode-border', className].filter(Boolean).join(' ')}>
      <div className="flex min-h-[44px] items-center justify-between gap-3 py-2 px-1">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          {crumbs ? <div className="text-[12px] vscode-text-tertiary leading-none">{crumbs}</div> : null}
          <h1 className="truncate text-[15px] font-semibold leading-tight vscode-text-primary">{title}</h1>
          {meta ? <p className="truncate text-[12px] vscode-text-tertiary">{meta}</p> : null}
        </div>
        {actionsEnd ? <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">{actionsEnd}</div> : null}
      </div>
    </div>
  );
}
